//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { UserLoginMixin, RouterHandlersMixin } from "@/mixins";
import { userPolicyCount } from "@/model/javaApi/apis";
import { ProfileStatus } from "@/utils/enum";
import { get } from "lodash";
import {mutations} from "@/observable/store";
import {CacheModule} from "@/utils/commonUtils";
export default {
  name: "my__header",
  mixins: [UserLoginMixin, RouterHandlersMixin],
  data() {
    return {
      avatar: "https://static.soyoung.com/sy-pre/avatar-1677737400779.png",
      insurancesListPath: "/MyInsurance",
      insuranceCount: null,
      insuranceCountLoading: false,
    };
  },
  computed: {
    userInfo() {
      if (this.logined && this.profile.phone) {
        /** 待完善 */
        if (!this.profile.name) {
          return {
            title: "待完善",
            subtitle: this.profile.phone,
            status: ProfileStatus.incomplete,
          };
        }
        /** 已完善 */
        return {
          title: this.profile.name,
          subtitle: this.profile.phone,
          status: ProfileStatus.completed,
        };
      }
      /** 未登录 */
      return {
        title: "未登录",
        subtitle: "点击登录/注册",
        status: ProfileStatus.notLogin,
      };
    },
  },
  activated() {
    console.error("触发 activated 声明周期", this.logined);
    console.error("触发 activated 声明周期", this.profile);
    // 先将 Disagree_User_Agreement 校验放置此处，若无法实现放置 this.logined 中尝试
    const disagreeUserAgreement = Boolean(localStorage.getItem("Disagree_User_Agreement"));
    if (disagreeUserAgreement) {
      mutations.getUid("0");
      mutations.getsyToken("");
      CacheModule.remove("userInfo");
    } else if (this.logined) {
      this.fetchMyInsuranceCount();
      this.getProfile();
    }
  },
  methods: {
    fetchMyInsuranceCount() {
      this.insuranceCountLoading = true;
      userPolicyCount()
        .then((res) => {
          const data = get(res, "data.data");
          this.insuranceCount = typeof data === "number" ? data : 0;
        })
        .catch((error) => {
          /** 此刻已登录/请求报错 */
          this.insuranceCount = 0;
        })
        .finally(() => {
          this.insuranceCountLoading = false;
        });
    },
    myInsuranceClickHandler() {
      this.STATISTICS("click", "insur_mall_my_policy_click", "jr");
      if (this.logined) {
        this.$router.push({
          path: this.insurancesListPath,
          query: {
            flag: "postdisable",
          },
        });
      } else {
        this.$refs.userLoginDialog.showoast();
      }
    },
    onHouseKeeperClick() {
      this.STATISTICS("click", "insur_mall_my_contact_click", "jr");
      this.myHouseKeeperClickHandler();
    },
    onLoginSuccess() {
      this.fetchMyInsuranceCount();
      this.getProfile();
    },
    profileClickHandler() {
      const status = this.userInfo.status;
      if (status === ProfileStatus.notLogin) {
        this.$refs.userLoginDialog.showoast();
        return;
      }
      this.$router.push({
        path: "personal-information",
        query: {
          status,
        },
      });
    },
  },
};
